export default __webpack_public_path__ + "dbff3c9eb6bf55af7e19a2fbbd3ff9c9.svg";